export default "__VITE_ASSET__f646b60b__"